module.exports = __webpack_public_path__ + "static/img/WM999-PF-A.0ad8610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WM999-PF-A.jpg
// module id = N4u6
// module chunks = 0